import { Flex } from '@mantine/core';
import type { PolicyMetricsOut } from '@repo/api-codegen';
import { memo, useCallback } from 'react';
import type { MetricCardType } from '../../types';
import { AlertIcon, NormalIcon } from '../icons';
import { MetricsOverviewCard } from '../MetricsOverviewCard';

export interface MetricsPolicyCardsProps {
	policyMetrics: PolicyMetricsOut;
	onMetricCardClick?: (metricType: MetricCardType) => void;
}

export const MetricsPolicyCards = memo(
	({ policyMetrics, onMetricCardClick }: MetricsPolicyCardsProps) => (
		<Flex py="lg" w="100%" justify="space-between" align="center" gap="md">
			<MetricsOverviewCard
				title="OK"
				value={policyMetrics?.ok ?? 0}
				icon={NormalIcon}
				onClick={useCallback(
					() => onMetricCardClick?.('Normal'),
					[onMetricCardClick]
				)}
			/>
			<MetricsOverviewCard
				title="Needs remediation"
				value={policyMetrics?.needs_remediation ?? 0}
				icon={AlertIcon}
				onClick={useCallback(
					() => onMetricCardClick?.('Error'),
					[onMetricCardClick]
				)}
			/>
		</Flex>
	)
);

MetricsPolicyCards.displayName = 'MetricsPolicyCards';
